export default __webpack_public_path__ + "static/media/placeholder_dummy2016-yoga02-mobile-de.98924c71.png";